import { createFeature, createReducer, on } from '@ngrx/store';
import { UiActions } from './ui.actions';

export interface UiState {
  sidebarCollapsed: boolean;
}

const initialState: UiState = {
  sidebarCollapsed: false,
};

const reducer = createReducer(
  initialState,
  on(UiActions.toggleSidebar, (state): UiState => ({
    ...state,
    sidebarCollapsed: !state.sidebarCollapsed,
  })),
  on(UiActions.setSidebarCollapsed, (state, { collapsed }): UiState => ({
    ...state,
    sidebarCollapsed: collapsed,
  })),
  on(UiActions.reset, (): UiState => initialState),
);

export const uiFeature = createFeature({
  name: 'ui',
  reducer,
});
